import React from 'react';
import PropTypes from 'prop-types';

import { Layout } from '../../components/Layout';
import { Background } from '../../components/Background';
import { App } from '../../components/App';

const Component = ({
  location,
  layout,
  background,
  children
}) => {
  const isHome = location && location.pathname === '/';
  const showAppChrome = (
    isHome
  ) || ['/news', '/music', '/charity', '/about', '/development', '/creative'].some(path => location.pathname.indexOf(path) === 0);

  return (
    <Layout {...layout}>
      <Background
        {...background}
        overlayVariant={isHome ? 'none' : (background.overlayVariant || 'default')}
        animation={{ show: true, ...background.animation }}
      >
        {showAppChrome ? <App>{children}</App> : children}
      </Background>
    </Layout>
  );
};

Component.displayName = 'Template';

Component.propTypes = {
  location: PropTypes.object.isRequired,
  layout: PropTypes.object,
  background: PropTypes.object,
  children: PropTypes.any
};

Component.defaultProps = {
  layout: {},
  background: {}
};

export { Component };
